export default __webpack_public_path__ + "static/MOC-7afddd62953942b5e1e14158378e8ccb.svg";